'use client';

import { TextButton } from '@/components/common/TextButton/TextButton';
import { PrefectureValue } from '@/constants/prefectures';
import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';

interface PrefectureLinkProps {
  code: PrefectureValue;
}

export function PrefectureLink({ code }: PrefectureLinkProps) {
  const searchParams = useSearchParams();
  const t = useTranslations('common.prefecture');

  const label = t(`label.${code}`);

  return (
    <Link
      href={{
        pathname: '/jobs',
        query: {
          ...Object.fromEntries(searchParams.entries()),
          prefecture: code,
        },
      }}
    >
      <TextButton size="small" fontWeight="bold">
        {label}
      </TextButton>
    </Link>
  );
}
